import React, { useState } from "react";
import { COLOR } from "../../constants/colors";

interface AuthModalProps {
  open: boolean;
  onClose: () => void;
  onSignIn: (provider: string) => void;
}

export default function AuthModal({ open, onClose, onSignIn }: AuthModalProps) {
  const [isAuthenticating, setIsAuthenticating] = useState(false);

  if (!open) return null;

  const handleLinkedInSignIn = () => {
    setIsAuthenticating(true);
    // Mock LinkedIn OAuth flow
    setTimeout(() => {
      onSignIn("linkedin");
      setIsAuthenticating(false);
    }, 1500);
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/40 p-4">
      <div className="bg-white rounded-3xl shadow-xl p-6 w-full max-w-md mx-auto relative">
        {!isAuthenticating && (
          <button
            className="absolute top-4 right-4 text-2xl font-bold hover:opacity-70 transition"
            onClick={onClose}
            aria-label="Close"
            style={{ color: COLOR.subtext }}
          >
            ×
          </button>
        )}

        {isAuthenticating ? (
          <div className="text-center py-8">
            <div className="flex items-center justify-center mb-4">
              <svg
                className="animate-spin h-12 w-12"
                style={{ color: "#0077B5" }}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
              </svg>
            </div>
            <h3
              className="text-xl font-extrabold mb-2"
              style={{ color: COLOR.text }}
            >
              Connecting to LinkedIn
            </h3>
            <p className="text-sm" style={{ color: COLOR.subtext }}>
              Please wait while we authenticate your account...
            </p>
          </div>
        ) : (
          <>
            <div className="flex items-center justify-center mb-4">
              <svg width="48" height="48" viewBox="0 0 32 32" fill="none">
                <rect width="32" height="32" rx="4" fill="#0077B5" />
                <path
                  d="M27 27h-4.5v-6.5c0-1.5-.5-2.5-2-2.5-1.5 0-2 1-2 2.5V27H14V13h4.5v2h.1c.6-1.1 2-2.2 4.1-2.2 3.1 0 4.3 2 4.3 5.1V27zM7.5 11.5c-1.5 0-2.5-1-2.5-2.5s1-2.5 2.5-2.5 2.5 1 2.5 2.5-1 2.5-2.5 2.5zM9.5 27H5.5V13h4V27z"
                  fill="white"
                />
              </svg>
            </div>
            <h2
              className="text-2xl font-extrabold mb-2 text-center"
              style={{ color: COLOR.text }}
            >
              Sign in with LinkedIn
            </h2>
            <p
              className="text-sm mb-6 text-center"
              style={{ color: COLOR.subtext }}
            >
              Tili will receive your name and profile information
            </p>

            <div className="space-y-3">
              <button
                onClick={handleLinkedInSignIn}
                className="w-full flex items-center justify-center gap-2 py-3 px-4 rounded-xl font-extrabold text-sm transition hover:opacity-90"
                style={{
                  backgroundColor: "#0077B5",
                  border: "2px solid #005983",
                  color: "white",
                }}
              >
                <svg width="20" height="20" viewBox="0 0 32 32" fill="none">
                  <path
                    d="M27 27h-4.5v-6.5c0-1.5-.5-2.5-2-2.5-1.5 0-2 1-2 2.5V27H14V13h4.5v2h.1c.6-1.1 2-2.2 4.1-2.2 3.1 0 4.3 2 4.3 5.1V27zM7.5 11.5c-1.5 0-2.5-1-2.5-2.5s1-2.5 2.5-2.5 2.5 1 2.5 2.5-1 2.5-2.5 2.5zM9.5 27H5.5V13h4V27z"
                    fill="white"
                  />
                </svg>
                Continue with LinkedIn
              </button>
            </div>
            <p
              className="mt-4 text-xs text-center"
              style={{ color: COLOR.subtext }}
            >
              By continuing, you agree to LinkedIn's User Agreement, Privacy
              Policy, and Cookie Policy.
            </p>
          </>
        )}
      </div>
    </div>
  );
}
